import { useEffect, useState } from "react";
import { Play, ImageOff } from "lucide-react";
import { api, mediaUrl } from "@/lib/api";
import { Lightbox } from "@/components/Lightbox";

export const MediaGallery = ({ businessId }) => {
  const [items, setItems] = useState([]);
  const [lb, setLb] = useState(null);

  useEffect(() => {
    if (!businessId) return;
    api.get(`/media/${businessId}`).then(({ data }) => setItems(data)).catch((e) => console.error("Failed to load media", e));
  }, [businessId]);

  if (items.length === 0) return <p data-testid="gallery-empty" className="text-slate-400 py-8 text-center">No photos or videos yet.</p>;

  return (
    <>
      <div data-testid="gallery-grid" className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {items.map((m, i) => (
          <button key={m.id} data-testid={`gallery-item-${m.id}`} onClick={() => setLb(i)} className="relative aspect-square rounded-xl overflow-hidden bg-slate-100 group">
            {m.media_type === "video" ? (
              <>
                <video src={mediaUrl(m.url)} className="h-full w-full object-cover" />
                <span className="absolute inset-0 flex items-center justify-center bg-black/30"><Play size={28} className="text-white" /></span>
              </>
            ) : (
              <img src={mediaUrl(m.url)} alt="" className="h-full w-full object-cover transition-transform group-hover:scale-105" />
            )}
          </button>
        ))}
      </div>
      <Lightbox items={items} index={lb} onClose={() => setLb(null)} onIndex={setLb} />
    </>
  );
};
